<template>
  <v-app-bar app bottom elevation='1' class='checkin-bottom-navigation'>
    <slot name='prev-button'/>
    <div class='flex-grow-1'/>
    <slot name='next-button'/>
  </v-app-bar>
</template>

<script>
  export default {
    name: 'CheckinBottomNavigation'
  }
</script>
